import { BaseModel } from "./base.model"
import { Moment } from "moment"
import { ExamRegistrationDecorator } from "decorators"

export class ExamRegistration extends BaseModel<ExamRegistration> {
    static DEFAULT_ATTRIBUTES = {
        examPassed: false
    }

    phone: string
    target: string
    mechanics: string
    address: string
    scheduledAt: Moment
    centerId: number
    cityId: string
    firstName: string
    lastName: string
    middleName: string
    driverLicense: string
    attemptId: string
    driverDbidUuid?: string
    licenseIssuedAt: Moment
    programId: number
    sessionLink: string
    token: string
    examPassed: boolean
    driverId: string
    uuid: string
    hubModerationId?: number
    hubModerationCourse?: string
    selfEmployed?: boolean
    rating?: number
    smartCaptchaToken?: string

    protected decorator: ExamRegistrationDecorator

    public decorate(): ExamRegistrationDecorator {
        if(!this.decorator) { this.decorator = new ExamRegistrationDecorator(this) }
        return this.decorator
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/exam-registration.model.ts